import { ReactNode } from 'react'

interface TextPageContainerProps {
    children: ReactNode
}

/**
 * Standard container for a page that's dominated by text, as opposed to a page
 * that's full-screen data, e.g. Content Search, or the Account Dashboard..
 *
 * Sets background colours and flex and margains and so on.
 */
export function TextPageContainer({ children }: TextPageContainerProps) {
    return (
        <div className="flex w-full flex-1 bg-gray-50 py-10">
            <div className="mx-auto flex w-full max-w-5xl flex-col px-6">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8">
                    {children}
                </div>
            </div>
        </div>
    )
}
